import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Icon from 'components/common/Icon/Icon'
import Text from 'components/common/Text/Text'
import Theme from 'components/common/Theme/Theme'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'

const ThreeStepperDynamicTitle = ({ contactInfoTitle, title, isDone, isActive = true }) =>
  <Wrapper contactInfoTitle={ contactInfoTitle }>
    {
      isActive ?
        isDone ?
          <Circle>
            <CheckIcon asset="check-white" contactInfoTitle={ contactInfoTitle } />
          </Circle> :
          <StyledIcon asset="arrow-right" /> :
        null
    }
    <Title underline={ isActive && !isDone } disabled={ !isActive }>{ title }</Title>
  </Wrapper>

ThreeStepperDynamicTitle.propTypes = {
  contactInfoTitle: PropTypes.bool,
  isActive: PropTypes.bool,
  isDone: PropTypes.bool,
  title: PropTypes.string
}

export default ThreeStepperDynamicTitle

const Wrapper = styled.div`
  ${props => props.contactInfoTitle && css`
    margin-bottom: 20px;
  `}
`

const Circle = styled.div`
  position: relative;
  display: inline-block;
  bottom: 2px;
  background-color: ${Theme.colors.green};
  border-radius: 10px;
  width: 20px;
  height: 20px;
  margin-right: 10px;
  ${Media.mobile`
    bottom: -1px;
    width: 15px;
    height: 15px;
  `}
`

const CheckIcon = styled(Icon)`
  position: relative;
  top: 2px;
  width: 21px;
  height: 11px;
  vertical-align: unset;
  ${Media.mobile`
    top: ${props => props.contactInfoTitle ? '-1px' : '-2px'};
    width: 15px;
    height: 9px;
  `}
`

const Title = styled(Text)`
  ${Mixin.font.GothamMedium(18)}
  text-transform: none;
  ${props => props.underline && css`
    text-decoration: underline;
  `}
  ${props => props.disabled && css`
    color: ${Theme.colors.grey};
  `}
`

const StyledIcon = styled(Icon)`
  position: relative;
  margin-right: 10px;
  bottom: 1px;
`
